<template>
    <div>
        <div class="vx-card px-6 py-4">
            <div class="vx-row">
                <div class="vx-col w-1/2">
                    <h3>Danh sách dịch vụ</h3>
                </div>
                <div class="vx-col w-1/2">
                    <vs-button class="float-right" @click="$router.push('/user/info-service-packs')" color="primary"
                               icon-pack="feather" icon="icon-plus" v-if="isPermissionCreateServicePacks">Thêm mới dịch vụ
                    </vs-button>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                    <label class="vs-input--label">Chi nhánh</label>
                    <v-select class="w-full" v-model="selectedBranch" :options="branchOptions"
                              :clearable="false"></v-select>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full md:mt-2">
                    <label class="vs-input--label">Phòng ban</label>
                    <v-select class="w-full" v-model="selectedDepartment" :options="departmentOptions"
                              :clearable="false"></v-select>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                    <label class="vs-input--label">Nhóm dịch vụ</label>
                    <v-select class="w-full" v-model="selectedServiceType" :options="serviceTypeOptions"
                              :clearable="false"></v-select>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                    <label class="vs-input--label">Tìm kiếm</label>
                    <vs-input class="w-full" v-model="keySearch" placeholder="Tìm kiếm theo tên hoặc mã"
                              v-on:keyup.enter="filter"></vs-input>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-2">
                    <div class="flex mt-2 xl:mt-8" v-if="!checkBox">
                        <label class="vs-input--label" style="align-self: flex-end;">Khoảng giá</label>
                         <vs-checkbox v-model="checkBox"></vs-checkbox>
                    </div>
                    <div class="flex mt-2 " v-else >
                        <label class="vs-input--label" style="align-self: flex-end;">Khoảng giá</label>
                         <vs-checkbox v-model="checkBox"></vs-checkbox>
                    </div>
                        <vs-slider color="primary" text-fixed=.000.000_VND ticks max=200 v-model="price" class=" w-full " v-if="checkBox"/>
                </div>
                <template lang="html">
</template>
                <div class="vx-col lg:w-1/3 md:w-1/2 w-full">
                    <vs-button class="md:mt-8 mt-2 md:float-right" iconPack="feather" icon="icon-search"
                               color="primary"
                               @click="getAllServicePack">Tìm kiếm
                    </vs-button>
                </div>
            </div>

            <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                         class="ag-theme-material w-100 ag-grid-table" :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="servicePackData" :animateRows="true" :pagination="true"
                         :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <div class="mt-4 flex flex-wrap" v-if="servicePackData.length > 0">
                <div class="">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 flex flex-wrap">
                        <span class="my-auto mr-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        servicePackData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : servicePackData.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="sm:ml-auto">
                    <vs-pagination class="" :total="totalPages" v-model="currentPage" @change="loadPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import Pagination from "../../../ui-elements/Pagination.vue";
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {

    data() {
        return {
            checkBox:false,
            branchOptions: [],
            selectedBranchValue: null,
            keySearch: null,
            serviceTypeOptions: [
                {value: null, label: 'Tất cả'},
            ],
            selectedServiceTypeValue: null,
            price: [0, 100],
            servicePackData: [],
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: 'Mã dịch vụ',
                    field: 'code',
                    width: 100
                },
                {
                    headerName: 'Tên dich vụ',
                    field: 'name',
                    width: 200
                },
                {
                    headerName: 'Giá (VND)',
                    field: 'unitPrice',
                    width: 200
                },
                {
                    headerName: 'Ghi chú',
                    field: 'description',
                    width: 150,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            pageNumber: 0,
            pageSize: 50,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            departmentOptions: [],
            selectedDepartmentValue: null,
        }
    },

    components: {
        vSelect,
        AgGridVue,
        CellRendererActions,
        Pagination,
    },

    computed: {
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                this.selectedDepartmentValue = null;
                this.selectedServiceTypeValue = null;
                this.getDepartment();
                this.getAllServiceType();
            }
        },

        selectedDepartment: {
            get() {
                let obj = this.departmentOptions.find(x => x.value === this.selectedDepartmentValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                this.selectedServiceTypeValue = null;
                this.getAllServiceType();
            }
        },

        selectedServiceType: {
            get() {
                let obj = this.serviceTypeOptions.find(x => x.value === this.selectedServiceTypeValue);
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedServiceTypeValue = obj ? obj.value : null;
            }
        },
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateVipCustomer'(val) {
            if (val) {
                this.getAllServicePack();
                this.$store.commit('UPDATE_VIP_CUSTOMER', false);
            }
        }
    },
    created() {

        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });
        this.branchOptions.unshift({value: null, label: 'Tất cả'});
        this.getAllServiceType();
        this.getAllServicePack();
        this.getDepartment();
    },

    methods: {

        getAllServicePack() {
            let body = {
                organizationBranchId: this.selectedBranchValue,
                departmentId: this.selectedDepartmentValue,
                beautyServiceId: this.selectedServiceTypeValue,
                keySearch: this.keySearch,
                minPrice: this.checkBox === false ? null : this.price[0] * 1000000,
                maxPrice: this.checkBox === false ? null : this.price[1] * 1000000,
                pageSize: this.pageSize,
                pageNumber: this.pageNumber,
            }

            this.$vs.loading();
            this.$crm.post('/beauty-service-package/find-by-condition', body).then(res => {
                this.servicePackData = res.data.content.map(el => {
                    el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                    if (el.unitPrice) el.unitPrice = el.unitPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    return el;
                });
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        getAllServiceType() {
            let payload = {
                organizationBranchId: this.selectedBranchValue,
                departmentId: this.selectedDepartmentValue,
            }

            this.$vs.loading();
            this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
                let result = res.data.content.map(el => {
                    return {
                        value: el.id,
                        label: el.code + '.' + el.name
                    }
                });
                this.serviceTypeOptions = [{value: null, label: 'Tất cả'},],
                    this.serviceTypeOptions.push(...result)
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        getDepartment() {
            let body = {
                organizationBranchId: this.selectedBranchValue,
            };

            this.$vs.loading();
            this.$crm.post('/department/find-by-condition', body).then(res => {
                this.departmentOptions = res.data.map(x => {
                    return {
                        value: x.id,
                        label: x.departmentName
                    }
                });

                this.departmentOptions.unshift({value: null, label: 'Tất cả'});
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getAllServicePack();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getAllServicePack();
        },

        filter() {
            this.currentPage = 1;
            this.pageNumber = 0;
            this.getAllServicePack();
        },

        isPermissionCreateServicePacks() {
            return isAPI(this, constAPI.beauty_service_pack_create);
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },

}
</script>
